import React from 'react';
import styles from './Card.scss';
import { Offer } from 'src/components/organisms/NewOffersSlider/types';
import cls from 'classnames';
import { AuthButton, CopyButton, LinkButton } from './CardButtons';

const enum OffersTypes {
  DirectDiscount = 'direct_discount',
  CommonDiscount = 'common_discount',
  PersonalPromo = 'personal_promo',
  CommonPromo = 'common_promo',
  ReferralPromo = 'referral_promo',
  ReferralLink = 'referral_link',
  DynamicLink = 'dynamic_link',
  Info = 'info',
}

const Card = ({ cardData, key, index }: { cardData: Offer; key: string; index: number }) => {
  const CardButton = ({index}: {index: number}) => {
    const locator = `OfferCardItem_${index}`
    /*
      Данный случай является исключением из остальных типов. Он имеет тип common_discount, а ссылка приходит action://authorize.
      Как вариант, со временем можно создать отдельный тип офера для авторизации, чтобы убрать эту часть кода.
    */
    const authLink = cardData.buttonLink?.match(/action:\/\/(.+)/i);
    if (authLink?.length && authLink[1] === 'authorize') {
      return <AuthButton cardData={cardData} locator={locator} />;
    }

    switch (cardData.type) {
      case OffersTypes.Info:
        return null;
      case OffersTypes.PersonalPromo:
      case OffersTypes.ReferralPromo:
      case OffersTypes.ReferralLink:
      case OffersTypes.DynamicLink:
      case OffersTypes.CommonPromo:
        return <CopyButton cardData={cardData} locator={locator} />;
      case OffersTypes.DirectDiscount:
      case OffersTypes.CommonDiscount:
      default:
        return <LinkButton cardData={cardData} locator={locator} />;
    }
  };

  const cardBackground =  cardData.disableDimming
    ? { backgroundImage: `url(${cardData.image})` }
    : { backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.7)), url(${cardData.image})` };

  return (
    <div
      className={styles.cardContainer}
      style={cardBackground}
      key={key}
      data-locator="OfferCard"
    >
      {cardData.label && (
        <div
          className={cls(styles.cardLabel, {
            [styles.whiteLabel]: cardData.labelColor === 'white',
          })}
        >
          {cardData.labelIcon && <img src={cardData.labelIcon} className={styles.labelIcon} />}
          <span className={styles.labelText}>{cardData.label}</span>
        </div>
      )}
      <div className={styles.contentBlock}>
        <div>
          <div className={styles.cardTitle} dangerouslySetInnerHTML={{ __html: cardData.title }} />
          <div
            className={styles.cardSubtitle}
            dangerouslySetInnerHTML={{ __html: cardData.description }}
          />
        </div>
        <CardButton index={index}/>
      </div>
    </div>
  );
};

export default Card;
